import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GET_SYSTEM_SETTINGS } from '../../apollo/queries/settingsQueries';
import '../css/OrderGuidePage.css';

const OrderGuidePage = () => {
    const navigate = useNavigate();
    const { data: settingsData } = useQuery(GET_SYSTEM_SETTINGS);

    const handleDownloadSample = () => {
        const settings = settingsData?.getSystemSettings;
        
        if (settings?.orderSampleFileUrl) {
            const link = document.createElement('a');
            link.href = settings.orderSampleFileUrl;
            link.download = settings.orderSampleFileName || 'order_sample.pdf';
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            alert('발주서 샘플 파일이 등록되지 않았습니다. 관리자에게 문의해주세요.');
        }
    };

    return (
        <div className="order-guide-page">
            <div className="og-breadcrumb">
                <span>홈</span> &gt; <span>내 정보</span> &gt; <span>견적 이력</span> &gt; <span className="current">발주 안내</span>
            </div>
            <h1 className="og-main-title">발주 안내</h1>

            <div className="og-progress-bar">
                <div className="og-progress-step active">
                    <div className="og-step-dot"></div>
                    <div>발주 안내</div>
                </div>
                <div className="og-progress-line active"></div>
                <div className="og-progress-step active">
                    <div className="og-step-dot"></div>
                    <div>발주 메일 확인</div>
                </div>
                <div className="og-progress-line active"></div>
                <div className="og-progress-step active">
                    <div className="og-step-dot"></div>
                    <div>제품 제작</div>
                </div>
            </div>

            {/* Step 1: 발주 안내 */}
            <div className="og-content-box">
                <p className="og-main-text">아래 방법으로 발주 메일을 요청드립니다.</p>
                <div className="og-info-box">
                    <p>귀사 견적이 실수가 없이 발주 될 수 있도록, 간단한 메일 발주 방식을 운영 중입니다.</p>
                    <ul>
                        <li><span className="og-label">메일 :</span> info@busbarworld.com</li>
                        {/* <li><span className="og-label">전화 :</span> 010-1234-5678</li> */}
                    </ul>
                </div>
                <p className="og-sub-text">발주서 파일 작성 후 위 메일주소로 보내주시면 됩니다.</p>
                <p className="og-sub-text">내용 확인 후 빠르고 정확한 출고를 도와드리겠습니다.</p>
            </div>


            <div className="og-actions">
                <button className="og-btn-light" onClick={handleDownloadSample}>
                    발주서 샘플 다운
                </button>
                <button className="og-btn-dark" onClick={() => navigate('/')}>홈으로 돌아가기</button>
            </div>
        </div>
    );
};

export default OrderGuidePage; 